import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, UndoIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { Lead } from '../types/leads';
interface RecentlyResolvedProps {
  resolvedLeads: Lead[];
  onUndo: (id: string) => void;
}
export function RecentlyResolved({
  resolvedLeads,
  onUndo
}: RecentlyResolvedProps) {
  const [isExpanded, setIsExpanded] = useState(resolvedLeads.length > 0);
  if (resolvedLeads.length === 0) {
    return null;
  }
  const formatTime = (isoString?: string) => {
    if (!isoString) return '';
    return new Date(isoString).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
  return <div className="bg-white rounded-xl shadow-sm border border-green-200 overflow-hidden" data-id="element-218">
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full px-6 py-4 flex items-center justify-between bg-green-50 hover:bg-green-100 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500" data-id="element-219">
        <div className="flex items-center" data-id="element-220">
          <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-221" />
          <h2 className="text-lg font-semibold text-green-900" data-id="element-222">
            Verified & On Lists
          </h2>
          <span className="ml-3 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-200 text-green-800" data-id="element-223">
            {resolvedLeads.length} Verified
          </span>
        </div>
        {isExpanded ? <ChevronUpIcon className="h-5 w-5 text-green-700" data-id="element-224" /> : <ChevronDownIcon className="h-5 w-5 text-green-700" data-id="element-225" />}
      </button>

      {isExpanded && <div className="border-t border-green-100" data-id="element-226">
          <div className="overflow-x-auto max-h-96 overflow-y-auto" data-id="element-227">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-228">
              <thead className="bg-gray-50 sticky top-0" data-id="element-229">
                <tr data-id="element-230">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-231">
                    Lead Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-232">
                    Source
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-233">
                    Pushed To List
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-234">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-235">
                    Verified At
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-236">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100" data-id="element-237">
                {resolvedLeads.map(lead => <tr key={lead.id} className="hover:bg-gray-50" data-id="element-238">
                    <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-239">
                      {lead.name}
                    </td>
                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-240">
                      {lead.leadSource}
                    </td>
                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900" data-id="element-241">
                      {lead.expectedDialingList}
                    </td>
                    <td className="px-6 py-3 whitespace-nowrap" data-id="element-242">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-243">
                        <ShieldCheckIcon className="h-3 w-3 mr-1" data-id="element-244" />
                        Verified
                      </span>
                    </td>
                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-245">
                      {formatTime(lead.resolvedAt)}
                    </td>
                    <td className="px-6 py-3 whitespace-nowrap text-right text-sm font-medium" data-id="element-246">
                      <button onClick={() => onUndo(lead.id)} className="inline-flex items-center text-gray-500 hover:text-red-600 transition-colors" title="Undo push" data-id="element-247">
                        <UndoIcon className="h-4 w-4 mr-1" data-id="element-248" />
                        Undo
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
    </div>;
}